<template>
  <v-app id="inspire">
    <v-main>
      <router-view class="view one"></router-view>
      <router-view class="view two" name="a"></router-view>
    </v-main>
    <core-footer />
  </v-app>
</template>

<script>
import UtilsMixin from "./mixins/UtilsMixin";

export default {
  name: "App",
  mixins: [UtilsMixin],
  title: "Virtual House Pro - Virtual Consulting for your Home Needs",
  components: {
    CoreFooter: () => import("@/components/core/Footer"),
  },
  data: () => ({
    drawer: null,
  }),
  computed: {
    userActionText() {
      return this.user ? "Logout" : "Login";
    },
  },
  methods: {
    userAction() {
      if (this.user) {
        this.$store
          .dispatch("signOutAction")
          .then(() => this.navigateTo("home"))
          .catch((err) => this.$store.commit("setError", err));
      } else {
        this.navigateTo("login");
      }
      this.$nextTick(() => {
        this.drawer = false;
      });
    },
  },
};
</script>

<style lang="scss">
.logo {
  max-height: 100%;
}
</style>
